import { environment } from '@env';

export const SERVER_CONFIG = {
    processorHostUrl: environment.API_ENDPOINT_APP,
    securityHostUrl: environment.API_ENDPOINT_SECURITY,
};
